import { ReactNode } from 'react';

import { OverlayContent, OverlayContentProps } from './OverlayContent';
import { HexIcon } from '../../hex-icons';
import * as Icons from '../../icons';

type Props = Omit<OverlayContentProps, 'title'> & { title?: ReactNode };

export const SuccessfullySubmittedOverlay = ({
  title = 'Changes successfully saved',
  testId = 'successfully-submitted-overlay',
  icon = (
    <HexIcon variant="success" icon={<Icons.CheckCircle weight="fill" />} />
  ),
  ...rest
}: Props) => {
  return <OverlayContent title={title} icon={icon} testId={testId} {...rest} />;
};
